import { Link } from 'react-router-dom';

function Footer() {
  return (
    <footer className="footer" id="contact">
      <div className="container">
        <div className="footer-content">
          <div className="footer-section">
            <div className="footer-logo">
              Vi Tillsammans
            </div>
            <p>Vi skapar gemenskap och glädje genom event för alla som behöver det.</p>
          </div>
          <div className="footer-section">
            <h4>Sidor</h4>
            <ul>
              <li><Link to="/home">Hem</Link></li>
              <li><Link to="/mission">Vår Mission</Link></li>
              <li><Link to="/gallery">Galleri</Link></li>
              <li><Link to="/bidra">Bidra</Link></li>
              <li><Link to="/anmalan">Anmälan</Link></li>
            </ul>
          </div>
          <div className="footer-section">
            <h4>Kontakt</h4>
            <p>
              <a href="mailto:Jultillsammans@gmail.com">Jultillsammans@gmail.com</a>
            </p>
            <div className="social-links">
              <a
                href="https://www.instagram.com/jultillsammans?utm_source=ig_web_button_share_sheet&igsh=ZDNlZDc0MzIxNw=="
                target="_blank"
                rel="noopener noreferrer"
                className="social-icon"
                aria-label="Instagram"
              >
                <i className="fab fa-instagram"></i>
              </a>
              <a
                href="https://www.facebook.com/share/1BMHvcqhY9/?mibextid=wwXIfr"
                target="_blank"
                rel="noopener noreferrer"
                className="social-icon"
                aria-label="Facebook"
              >
                <i className="fab fa-facebook-f"></i>
              </a>
            </div>
          </div>
        </div>
        <div className="footer-bottom">
          <p>&copy; 2025 Vi Tillsammans. Alla rättigheter förbehållna.</p>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
